import script from "./ViewAllGeneralContractors.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllGeneralContractors.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllGeneralContractors.vue?vue&type=style&index=0&id=8c3a926e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c3a926e"]])

export default __exports__